import React, { Component } from 'react'
import ProductDetail from './ProductDetail'
import ColorPicker from './ColorPicker'
import FallbackImage from './FallbackImage'
import NoImagePlaceholder from '../images/missing_image_large.png'
import _ from 'lodash'

import * as StyledComponent from '../styles'

const image_placeholder = <img
  className='product-image-default'
  alt=''
  src={NoImagePlaceholder}
/>

class ProductBox extends Component {
  constructor(props) {
    super(props)
    this.state = {
      product: {},
      color_options: [],
      selected_color_option: {},
      selected_size_option: {},
      hide_variants: []
    }
  }

  handleColorOptionSelection = color_id => {
    const selected_color_option = _.find(this.state.color_options, ['id', color_id]) || _.head(this.state.color_options)
    this.setState({
      selected_color_option
    })
  }

  componentDidMount() {
    const { product_sku = {} } = this.props
    const { product = {} } = product_sku
    const { color_options = [], size_options = [], hide_variants = [] } = product
    const selected_color_option = _.head(color_options)
    const selected_size_option = _.head(size_options)

    this.setState({
      product,
      color_options,
      selected_color_option,
      selected_size_option,
      hide_variants
    })
  }

  _prepareColorOptionsPlaceholder = (color_option_ids) => {
    const color_option_placeholders = _.map(color_option_ids, (value) => {
      return {
        id: value,
        hex_value: '#EEEEEE'
      }
    })
    return color_option_placeholders
  }

  render() {
    const { product_sku = {} } = this.props
    const { product = {} } = product_sku
    const { color_option_ids = [] } = product
    const {
      color_options = [],
      selected_color_option = {},
      selected_size_option = {},
      hide_variants = []
    } = this.state
    const { default_image = {}, images = [] } = selected_color_option
    const hide_color_option = _.includes(hide_variants, 'color_option')
    const current_image = _.isEmpty(default_image)
      ? _.head(images)
      : default_image
    const is_color_switch_placeholder = _.isEmpty(color_options) && !_.isEmpty(color_option_ids)

    // let params = {
    //   product_id: product.id,
    //   color_option_id: selected_color_option.id
    // }

    let details_props = {
      product_sku,
      selected_color_option,
      selected_size_option,
      add_to_bag_loading: this.props.add_to_bag_loading,
      add_to_bag_loading_id: this.props.add_to_bag_loading_id,
      addToBag: this.props.onAddToBag,
    }

    let picker_props = {
      is_color_switch_placeholder,
      product_id: product.id,
      colors: is_color_switch_placeholder
        ? this._prepareColorOptionsPlaceholder(color_option_ids)
        : color_options,
      selected_color: selected_color_option,
      selectColor: is_color_switch_placeholder
        ? () => {}
        : this.handleColorOptionSelection
    }

    return <StyledComponent.ProductBox className='product-box'>
      <div className='product-imgbox'>
        {
          _.isEmpty(current_image)
            ? image_placeholder
            : <FallbackImage
              className='product-image'
              fallback_className='product-image-default'
              src={current_image.versions.mobile_medium}
              alt=''
            />
        }
      </div>
      <ProductDetail {...details_props} />
      {
        !hide_color_option &&
          picker_props.colors.length > 1 &&
            <ColorPicker {...picker_props} />
      }
    </StyledComponent.ProductBox>
  }
}

ProductBox.defaultProps = {
  product_sku: {},
  onAddToBag: () => {}
}

export default ProductBox



// WEBPACK FOOTER //
// ./src/components/ProductBox.js